import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import { restBaseApi } from "./api";
import { graphqlBaseApi } from "./graphqlBaseApi";
import loginReducer from "../core/login/loginSlice";
import userReducer from "../features/users/userSlice";
import filterReducer from "../core/filter/filterSlice";
import amlReducer from "../core/scenes/investor-aml/amlSlice";
import authReducer from "./authSlice";

export const store = configureStore({
  reducer: {
    [restBaseApi.reducerPath]: restBaseApi.reducer,
    [graphqlBaseApi.reducerPath]: graphqlBaseApi.reducer,
    filter: filterReducer,
    login: loginReducer,
    userReducer,
    amlReducer,
    auth: authReducer,
  },
  middleware: (gDM) => gDM().concat(restBaseApi.middleware, graphqlBaseApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
